import React, { useState } from 'react';
import { TagIcon, TruckIcon } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { formatPrice } from '../../utils/formatters';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';
interface CartSummaryProps {
  onCheckout?: () => void;
}
export function CartSummary({
  onCheckout
}: CartSummaryProps) {
  const {
    subtotal,
    shippingCost,
    total,
    itemCount
  } = useCart();
  const [couponCode, setCouponCode] = useState('');
  const [couponError, setCouponError] = useState('');
  const [discount, setDiscount] = useState(0);
  const handleApplyCoupon = () => {
    if (couponCode.toUpperCase() === 'SAVE10') {
      setDiscount(subtotal * 0.1);
      setCouponError('');
    } else {
      setCouponError('Invalid coupon code');
      setDiscount(0);
    }
  };
  const finalTotal = total - discount;
  return <div className="bg-white rounded-xl border border-gray-100 shadow-card p-6" data-id="element-60" data-mp="1mu5woztcggck">
      <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-61" data-mp="27ajsch5nk2or">
        Order Summary
      </h2>

      <div className="space-y-3 text-sm" data-id="element-62" data-mp="22bgoh01es2id">
        <div className="flex justify-between" data-id="element-63" data-mp="22ae0azvh0e65">
          <span className="text-gray-600" data-id="element-64" data-mp="229may6sgvcob">Subtotal ({itemCount} items)</span>
          <span className="font-medium text-gray-900" data-id="element-65" data-mp="2g226ynmyaafq">
            {formatPrice(subtotal)}
          </span>
        </div>

        <div className="flex justify-between" data-id="element-66" data-mp="2c3mfo7ju6fwi">
          <span className="text-gray-600 flex items-center gap-1" data-id="element-67" data-mp="1ocpbjgya8mvt">
            <TruckIcon className="w-4 h-4" data-id="element-68" data-mp="1jcumliy2i7de" />
            Shipping
          </span>
          <span className="font-medium text-gray-900" data-id="element-69" data-mp="1jexigjlwiuq1">
            {shippingCost === 0 ? <span className="text-green-600" data-id="element-70" data-mp="1xdnjubfr7gk7">Free</span> : formatPrice(shippingCost)}
          </span>
        </div>

        {discount > 0 && <div className="flex justify-between text-green-600" data-id="element-71" data-mp="38r95vnqbh21i">
            <span className="flex items-center gap-1" data-id="element-72" data-mp="38poda3nkbt6a">
              <TagIcon className="w-4 h-4" data-id="element-73" data-mp="33t7nz64mn8rm" />
              Discount
            </span>
            <span className="font-medium" data-id="element-74" data-mp="21fjjeps2ml6u">-{formatPrice(discount)}</span>
          </div>}
      </div>

      {/* Coupon code */}
      <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-75" data-mp="26d1xeuky3qlp">
        <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-76" data-mp="2afopmwlj3djf">
          Have a coupon code?
        </label>
        <div className="flex gap-2" data-id="element-77" data-mp="2ffb3n896kxta">
          <Input type="text" placeholder="Enter code" value={couponCode} onChange={e => setCouponCode(e.target.value)} error={couponError} className="flex-1" data-id="element-78" data-mp="2fe9iuc2d4wyd" />
          <Button variant="outline" onClick={handleApplyCoupon} data-id="element-79" data-mp="1mpm2muwh0xro">
            Apply
          </Button>
        </div>
        <p className="text-xs text-gray-500 mt-2" data-id="element-80" data-mp="1ro5pcxiw2dl3">Try: SAVE10 for 10% off</p>
      </div>

      {/* Total */}
      <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-81" data-mp="1wgp43xtbberh">
        <div className="flex justify-between items-center" data-id="element-82" data-mp="z0t0uht63vp5">
          <span className="text-lg font-semibold text-gray-900" data-id="element-83" data-mp="z09ln8uwjlet">Total</span>
          <span className="text-2xl font-bold text-gray-900" data-id="element-84" data-mp="13ybdojab2v2f">
            {formatPrice(finalTotal)}
          </span>
        </div>
        <p className="text-xs text-gray-500 mt-1" data-id="element-85" data-mp="we0qwexb9xsh">Including all taxes</p>
      </div>

      {/* Checkout button */}
      <Button variant="primary" size="lg" fullWidth className="mt-6" onClick={onCheckout} disabled={itemCount === 0} data-id="element-86" data-mp="mhxfeigkkmsv">
        Proceed to Checkout
      </Button>

      {/* Free shipping notice */}
      {shippingCost > 0 && <div className="mt-4 p-3 bg-primary-50 rounded-lg" data-id="element-87" data-mp="dgzck3hvalbv">
          <p className="text-sm text-primary-700" data-id="element-88" data-mp="djc0cxab3pwu">
            Add {formatPrice(5000 - subtotal)} more to get{' '}
            <strong data-id="element-89" data-mp="8opqiyjvi5ev">FREE shipping!</strong>
          </p>
        </div>}
    </div>;
}